import * as fromRoot from '../../reducers';
import {ActionReducerMap, createFeatureSelector, createSelector} from '@ngrx/store';
import * as fromCms from '../reducers/cms.reducer';

export interface State extends fromRoot.State {
    shared: SharedState;
}

export interface SharedState {
    cms: fromCms.State;
}

export const sharedReducers: ActionReducerMap<SharedState> = {
    cms: fromCms.cmsBlockReducer,
};

// selectors

export const selectCmsState = createFeatureSelector<fromCms.State>('cms');

export const getAllBlocks = createSelector(
    selectCmsState,
    fromCms.getAllBlocks
);

// cms entity state
export const getBlock = (props: { blockId: string }) =>
    createSelector(getAllBlocks, (blocks) => {
        return blocks.find((block) => block.identifier === props.blockId);
    });

export const getLandingPageBlocks = () =>
    createSelector(getAllBlocks, (blocks) => {
        return blocks.filter((block) => block.identifier.startsWith("cms_"));
    });
